import { Box, Button, List, ListItemIcon, ListItemText } from "@mui/material";
import { ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Mensagem } from "./types";
import MessageOutlineIcon from "@mui/icons-material/MessageOutlined";

import "./notificacoes.css";
import { Notification } from "../../apis/notification-center-service";

type ListaMensagensProps = {
  mensagens: Notification[];
  handleClick: Function;
};

export const ListaMensagens: React.FC<ListaMensagensProps> = ({
  mensagens,
  handleClick,
}) => {
  const mensagensTodas = mensagens || [];
  const mensagensNaoLidas = mensagensTodas.filter((msg) => !msg.read);

  const [mensagensListagem, setMensagensListagem] =
    useState<Notification[]>(mensagensTodas);

  const [showTodas, setShowTodas] = useState<boolean>(true);

  useEffect(() => {
    if (mensagens) {
      setMensagensListagem(mensagensTodas);
    }
  }, [mensagens]);

  const handleExibirTodas = () => {
    setMensagensListagem(mensagensTodas);
    setShowTodas(true);
  };

  const handleExibirNaoLidas = () => {
    setMensagensListagem(mensagensNaoLidas);
    setShowTodas(false);
  };

  let conteudo = [<React.Fragment />];

  if (mensagensListagem.length > 0) {
    conteudo = mensagensListagem.map((msg: Notification) => (
      <ListItem
        key={msg.id}
        className={msg.read ? "list-item msg-lida" : "list-item"}
        onClick={() => handleClick(msg)}
      >
        <ListItemIcon className={"icone-msg"}>
          <MessageOutlineIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Box className={"titulo-msg"}>
              <div>{msg.content?.title}</div>
              <span>&#x2022;</span>
            </Box>
          }
          secondary={
            <React.Fragment>
              <span className={"texto-msg"}>{msg.content?.body}</span>
              <span className={"data-msg"}>{msg.createdAt}</span>
            </React.Fragment>
          }
        />
      </ListItem>
    ));
  } else {
    conteudo = [
      <ListItem className="list-item msg-lida" key={0}>
        <ListItemText
          primary={
            <Box className={"titulo-msg"}>
              <div>Não há mensagens para serem exibidas.</div>
            </Box>
          }
        />
      </ListItem>,
    ];
  }

  return (
    <Box>
      <Box className="barra-btn">
        <Button
          variant={showTodas ? "contained" : "text"}
          sx={{ color: showTodas ? "#fff" : "#3D445C" }}
          size="small"
          onClick={handleExibirTodas}
        >
          Todas
        </Button>
        <Button
          variant={showTodas ? "text" : "contained"}
          sx={{ color: showTodas ? "#3D445C" : "#fff" }}
          size="small"
          onClick={handleExibirNaoLidas}
        >
          Não Lidas
        </Button>
      </Box>
      <List className={"list"}>{conteudo}</List>
    </Box>
  );
};
